import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxExcelWordCount' })
export class NgxExcelWordCountPipe implements PipeTransform {

  transform(value: string): number {
    return value.length;
  }

}
